export function Skeleton({ className = '', style }) {
  return <div className={`skeleton ${className}`.trim()} style={style} aria-hidden="true" />;
}

export { default as CasinoFrontSkeleton } from './CasinoFrontSkeleton';
export { default as SiteSkeleton } from './CasinoFrontSkeleton';

export function GameCardSkeleton() {
  return (
    <div className="casino-front-skeleton__game-card" aria-hidden="true">
      <div className="casino-front-skeleton__game" />
      <div className="casino-front-skeleton__card-label">
        <div className="casino-front-skeleton__card-name" />
        <div className="casino-front-skeleton__card-dev" />
      </div>
    </div>
  );
}

export function LogoSkeleton() {
  return <Skeleton className="logo-skeleton" />;
}

export function HeaderNavSkeleton({ count = 4 }) {
  return (
    <div className="header-nav-skeleton" aria-hidden="true">
      {Array.from({ length: count }, (_, i) => (
        <Skeleton key={i} className="header-nav-skeleton__item" />
      ))}
    </div>
  );
}

export function HeaderAuthSkeleton() {
  return (
    <div className="header-auth header-auth--skeleton" aria-hidden="true" aria-busy="true">
      <Skeleton className="header-auth-skeleton__btn header-auth-skeleton__btn--login" />
      <Skeleton className="header-auth-skeleton__btn header-auth-skeleton__btn--join" />
    </div>
  );
}

export function WelcomeBannerSkeleton() {
  return (
    <section className="welcome-banner welcome-banner--skeleton welcome-banner--photo" aria-hidden="true">
      <div className="welcome-banner__content">
        <div className="welcome-banner__img-fader">
          <Skeleton className="welcome-banner-skeleton__img" />
        </div>
      </div>
    </section>
  );
}

export function CasinoSliderSkeleton() {
  return (
    <div className="casino-slider-wrap casino-slider-wrap--skeleton casino-slider-wrap--photo" aria-hidden="true">
      <div className="casino-slider">
        <div className="casino-slider__inner">
          <Skeleton className="casino-slider-skeleton__img" />
        </div>
      </div>
    </div>
  );
}

export function FooterSponsorsSkeleton() {
  return (
    <div className="footer__sponsors footer__sponsors--skeleton" aria-hidden="true">
      {Array.from({ length: 6 }, (_, i) => (
        <Skeleton key={i} className="footer-skeleton__sponsor" />
      ))}
    </div>
  );
}
